import React, { useState, useRef } from "react";
import styles from "./CheckoutPanel.module.css";
import { Grid, Button, TextField } from "@mui/material";
import PaymentSummery from "../Checkout/paymentSummery";
import { useGetAllCartItemsQuery } from "../../Store/Services/CartService";
import CheckoutItems from "../Checkout/checkoutItems";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getGlobalCartId } from "../../Utils/cartSession";

const CheckoutPanel = () => {
  const [selectedPayment, setSelectedPayment] = useState("");
  const [paymentAmount, setPaymentAmount] = useState(0);
  const componentRef = useRef(null);
  const currency = useSelector((state) => {
    console.log("Currency Symbol:", state.currency.currencySymbol);
    console.log("Currency Rate:", state.currency.currencyRate);
    return state.currency;
  });
  let cartId;
  if (typeof window !== "undefined") {
    cartId = getGlobalCartId();
  }
  console.log(cartId);

  let items = [],
    orderDet;

  const { data, isSuccess, isLoading } = useGetAllCartItemsQuery(cartId);
  if (isSuccess) {
    items = data.orderDetails.items;
    orderDet = data.orderDetails;
  }

  const totalPayment = parseFloat(orderDet?.totPay || 0).toFixed(2);
  const balance = (paymentAmount - totalPayment).toFixed(2);

  return (
    <Grid
      container
      spacing={12}
      className={styles.container}
      style={{ marginBottom: "3rem" }}
    >
      <Grid item xs={12} md={6} className={styles.bottomRow}>
        <Grid container spacing={2} className={styles.paymentOptions}>
          <Grid item xs={6}>
            <Button
              className={
                selectedPayment === "cash"
                  ? styles.selectedButton
                  : styles.button
              }
              onClick={() => setSelectedPayment("cash")}
              fullWidth
            >
              Cash
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              className={
                selectedPayment === "card"
                  ? styles.selectedButton
                  : styles.button
              }
              onClick={() => setSelectedPayment("card")}
              fullWidth
            >
              Card
            </Button>
          </Grid>
        </Grid>

        {selectedPayment === "cash" && (
          <>
            <div className={styles.formContainer}>
              <TextField
                placeholder="Enter the Payment"
                type="text"
                value={paymentAmount}
                onChange={(e) => {
                  const value = e.target.value.replace(/^0+(?!\.|$)/, "");
                  setPaymentAmount(parseFloat(value) || 0);
                }}
                className={`${styles.formInput} ${styles.widerTextField}`}
                fullWidth
              />
            </div>
            <div className={styles.balanceContainer}>
              <div className={styles.balanceText}>Balance:</div>
              <div className={styles.balanceAmount}>
                {currency.currencySymbol}
                {balance}
              </div>
            </div>

            <div className={styles.formContainer}>
              <ReactToPrint
                trigger={() => (
                  <Button
                    style={{
                      backgroundColor: "#880202",
                      color: "white",
                      fontSize: "20px",
                      borderRadius: "5px",
                      borderColor: "#880202",
                      padding: "8px 50px",
                      marginTop: "20px",
                    }}
                    fullWidth
                    disabled={balance < 0} 
                    onClick={() => {
                      if (balance >= 0) {
                      } else {
                        toast.error(
                          "Payment is not sufficient to complete the transaction!",
                          { position: "bottom-right" }
                        );
                        console.log(
                          "Payment is not sufficient to complete the transaction."
                        );
                      }
                    }}
                  >
                    Complete
                  </Button>
                )}
                content={() => componentRef.current}
                contentStyle={{
                  size: "80mm 297mm",
                  margin: "0",
                  orientation: "portrait",
                }}
              />
            </div>
          </>
        )}
        {selectedPayment === "card" && (
          <div className={styles.formContainer}>
            <ReactToPrint
              trigger={() => (
                <Button
                  style={{
                    backgroundColor: "#880202",
                    color: "white",
                    fontSize: "20px",
                    borderRadius: "5px",
                    borderColor: "#880202",
                    padding: "8px 50px",
                    marginTop: "20px",
                  }}
                  fullWidth
                >
                  Complete
                </Button>
              )}
              content={() => componentRef.current}
              contentStyle={{
                size: "80mm 297mm",
                margin: "0",
                orientation: "portrait",
              }}
            />
          </div>
        )}
      </Grid>

      <Grid item xs={12} md={6} className={styles.amountPanel}>
        <div ref={componentRef}>
          <div className={styles.printtitle}>INVOICE</div>
          {/* <CheckoutItems cartId={cartId} /> */}
          <div 
          style={{ 
            backgroundColor: "#C2A0A0", 
            marginTop: "2rem" 
            }}>
            <div
              className={`${styles.productDetails} ${styles.priceContainer}`}
            >
              <PaymentSummery
                items={items}
                orderDet={orderDet}
                cartId={cartId}
              />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default CheckoutPanel;
